import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  preserveAspectRatio: "xMidYMid",
  style: {"margin":"auto","display":"block","shape-rendering":"auto"},
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "32",
      fill: "none",
      stroke: "currentColor",
      "stroke-dasharray": "150.79644737231007 52.26548245743669",
      "stroke-width": "14"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        dur: "1s",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        type: "rotate",
        values: "0 50 50;360 50 50"
      })
    ], -1)
  ])))
}
export default { render: render }